export enum ApiServiceStatusEnum {
  Available = 'Available',
  InstallRequired = 'InstallRequired',
  ScopeRequestRequired = 'ScopeRequestRequired'
}
